import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable, of, Subject, Subscriber } from 'rxjs';
import { GoalEndpoints, GoalRouteUrls, SportEndpoints, BettingConfigsEndpoints, systemConfigs } from '../utilities/config';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { SystemConfigField } from '../interface/interfaces';
import * as  crypto from 'crypto-js';
import { CurrencyParam } from '../interface/currency-param.modle';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  ServiceUrls: any;
  GATEWAY_GAMEFILES: any;
  RISK_CONFIG_GATEWAY: any;
  lang: string = ""
  currencyData: CurrencyParam;

  constructor(private http: HttpClient) {
    this.currencyData = {
      strCode: 'XOF',
      bDefault: true,
      dbValue: 1,
      strGroupingSeparator: ',',
      strDecimalSeparator: '.',
      strDisplayFormat: '#,###,###,##0',
      bCodeAppendedEnd: true,
      bAddCodeValueSeparator: true,
      strCodeValueSeparator: ' ',
      intFractionsCount: 0,
    }
// console.log('Before call from config service ');


  }
  $config: Subject<any> = new Subject();
  MAIN_GATEWAY = '';
  regex = {
    pseudo: /^[a-zA-Z0-9]*$/,
    email: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{8,20}$/,
    phone: /^\+?[1-9]\d{1,14}$/,
  }
  GATEWAY_ADMIN_ = '';
  PAYMENT_GATEWAY = '';
  GATEWAY_DASHBOARD = '';
  NOTIFICATION_GATEWAY = '';
  GATEWAY_TRANSACTION = '';
  TAX_REGULATION_GATEWAY = '';
  SYSTEM_CONFIG: Record<SystemConfigField, any> = {
    'countryCode': '',
    'currency': '',
    'phoneNumberLength': 0
  }
  GATEWAY_TICKET = '';
  GATEWAY_CONFIG = '';
  GATEWAY_ADMIN = '';
  DEMO_GATEWAY = '';
  // GATEWAY = '';
  GATEWAY_LOGIN = '';
  GATEWAY_IMAGES = '';
  GATWAY_PUB_IMAGES = '';
  GATEWAY_AGENT = ''
  RiskConfigServiceUrls: any = {};
  PREFEREPDF = false;
  PROXIES = {
    login: '',
    sport_admin_services: '',
  };
  GOAL_CONFIGS = GoalEndpoints;
  EVENT_RESTRICTIONS = BettingConfigsEndpoints.eventRestrictions;
  GOAL_ROUTES = GoalRouteUrls;
  SPORTS_CONFIGS = SportEndpoints;
  AuthParams = environment.authParams;
  loadConfigs() {
    this.http.get('assets/config/config.json').subscribe(
      (res: any) => {
        this.MAIN_GATEWAY = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_ADMIN_ = res.gateways.GATEWAY_ADMIN_;
        this.PAYMENT_GATEWAY = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_DASHBOARD = res.gateways.MAIN_GATEWAY;
        this.NOTIFICATION_GATEWAY = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_TRANSACTION = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_TICKET = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_CONFIG = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_ADMIN = res.gateways.GATEWAY_ADMIN_;
        this.GATEWAY_LOGIN = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_GAMEFILES = res.gateways.GATEWAY_GAMEFILES;
        this.GATEWAY_IMAGES = res.gateways.MAIN_GATEWAY;
        this.GATWAY_PUB_IMAGES = res.gateways.MAIN_GATEWAY;
        this.GATEWAY_AGENT = res.gateways.GATEWAY_AGENT;
        this.ServiceUrls = res.services;
        this.PREFEREPDF = res.preferePdf;
        this.RISK_CONFIG_GATEWAY = res.gateways.RISK_CONFIG_GATEWAY;
        this.TAX_REGULATION_GATEWAY = res.gateways.TAX_REGULATION_GATEWAY;
        this.DEMO_GATEWAY = res.gateways.DEMO_GATEWAY;
        // console.log(this.ServiceUrls)
        this.RiskConfigServiceUrls = {
          CreateUpdateThresholdRuleGroup: this.RISK_CONFIG_GATEWAY + 'threshold-config/create-update-threshold-rule-group',
          GetThresholdRuleGroups: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-threshold-rule-groups',
          GetThresholdRuleGroup: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-threshold-rule-group',

          GetEnumsByType: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-enums-by-type',
          GetMonitorElementTypes: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-monitor-element-type',
          GetMonitorElementScopes: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-monitor-element-scope',

          CreateUpdateMonitorElement: this.RISK_CONFIG_GATEWAY + 'threshold-config/create-update-monitor-element',
          GetMonitorElements: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-monitor-elements',
          GetMonitorElement: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-monitor-element',

          CreateUpdateThreshold: this.RISK_CONFIG_GATEWAY + 'threshold-config/create-update-threshold',
          GetThresholds: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-thresholds',
          GetThreshold: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-threshold',

          CreateUpdateThresholdRule: this.RISK_CONFIG_GATEWAY + 'threshold-config/create-update-threshold-rule',
          GetThresholdRules: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-threshold-rules',
          GetThresholdRule: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-threshold-rule',
          RemoveThresholdRule: this.RISK_CONFIG_GATEWAY + 'threshold-config/remove-threshold-rule',


          CreateUpdateLimit: this.RISK_CONFIG_GATEWAY + 'threshold-config/create-update-limit',
          GetLimits: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-limits',
          GetLimitsByType: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-limits-by-type',
          GetLimit: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-limit',

          GetFixtures: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-fixtures',
          GetMarkets: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-markets',
          GetSearchFixtures: this.RISK_CONFIG_GATEWAY + 'threshold-config/search-fixtures',
          GetFixtureMarkets: this.RISK_CONFIG_GATEWAY + 'threshold-config/get-fixture-markets',

          CreateUpdateAlert: this.RISK_CONFIG_GATEWAY + 'alert-config/create-update-alert',
          GetAlerts: this.RISK_CONFIG_GATEWAY + 'alert-config/get-alerts',
          GetThresholdRuleAlerts: this.RISK_CONFIG_GATEWAY + 'alert-config/get-threshold-rule-alerts',
          GetAlertTypes: this.RISK_CONFIG_GATEWAY + 'alert-config/get-alert-types',
          GetAlertLevels: this.RISK_CONFIG_GATEWAY + 'alert-config/get-alert-levels',
          RemoveAlert: this.RISK_CONFIG_GATEWAY + 'alert-config/remove-alert',

          CreateUpdateAction: this.RISK_CONFIG_GATEWAY + 'action-config/create-update-action',
          GetAlertActions: this.RISK_CONFIG_GATEWAY + 'action-config/get-alert-actions',
          GetActionTypes: this.RISK_CONFIG_GATEWAY + 'action-config/get-action-types',
          GetAction: this.RISK_CONFIG_GATEWAY + 'action-config/get-action',
          GetActionElementTypes: this.RISK_CONFIG_GATEWAY + 'action-config/get-action-element-types',
          RemoveAction: this.RISK_CONFIG_GATEWAY + 'action-config/remove-action',

          CreateUpdateNotification: this.RISK_CONFIG_GATEWAY + 'notification-config/create-update-notification',
          GetAlertNotifications: this.RISK_CONFIG_GATEWAY + 'notification-config/get-alert-notifications',
          GetRoutes: this.RISK_CONFIG_GATEWAY + 'notification-config/get-routes',
          GetMessageTemplates: this.RISK_CONFIG_GATEWAY + 'notification-config/get-message-templates',
          RemoveNotification: this.RISK_CONFIG_GATEWAY + 'notification-config/remove-notification',

          GetSports: this.PROXIES.sport_admin_services + '/sport/find',
          GetCategories: this.PROXIES.sport_admin_services + '/category/find',
          GetTournaments: this.PROXIES.sport_admin_services + '/tournament/find',
        };

        this.PROXIES = {
          login: this.MAIN_GATEWAY + 'login-service/flex_bet_services_v3',
          sport_admin_services: this.GATEWAY_ADMIN + '/admin',
        };
        this.$config.next(res);
        this.$config.complete();
      }
    );
  }

  getBase64Hash(params: string) {
    const hash = crypto.HmacSHA256(params, this.AuthParams.RequestHmacKey);
    return crypto.enc.Base64.stringify(hash);
  }

  getSystemConfigs() {
    let url = `/v2/system/configs`;
    let headers = new HttpHeaders({
          'Content-Type': 'application/json; charset=UTF-8',
          'Content-Signature': this.AuthParams.username + ':' + this.getBase64Hash(this.AuthParams.username + url),
        });
    return this.http.get(this.GATEWAY_ADMIN + url, { headers }).pipe(
      map((res) => {
        if(res.hasOwnProperty("erc") && Number(res['erc']) === 1){
          let data: {key: string, value: any}[] = res['data'];

          systemConfigs.map((config) => {
            let index = data.findIndex((d) => d.key === config.key);
            let name = config.name;
            let value = index > -1 ? data[index].value : config.default;
            this.SYSTEM_CONFIG[name] = value;
            this.currencyData = {
              ...this.currencyData,
              strCode: this.SYSTEM_CONFIG['currency'] || 'XOF',
            }
          });
          return true;
        }else {
          systemConfigs.forEach((config) => {
            this.SYSTEM_CONFIG[config.name] = config.default;
          });

          return false;
        }
      }),
      catchError((err) => {
        systemConfigs.forEach((config) => {
          this.SYSTEM_CONFIG[config.name] = config.default;
        });
        return of(false);
      }),
    );
  }
}
